import React from 'react';
import { AnimatedTitle } from './AnimatedTitle';
import { Reveal } from './Reveal';
import { contacto, imagenes } from '../data/site';
export function Contacto() {
  return <section id="contacto" className="relative isolate w-full bg-black py-24 lg:py-32" data-id="element-18" data-mp="1g74vosytgklj">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-[#B8391A] to-transparent lg:h-40" data-id="element-19" data-mp="1g5bnvacgvuby" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:gap-20 lg:px-12" data-id="element-20" data-mp="nk212bx9gu0k">
        <Reveal data-id="element-21" data-mp="sfhc6w3vwbta">
          <img src={imagenes.fachada} alt="Fachada del local de Magia Poderosa en Miami, con vitrina iluminada" loading="lazy" className="aspect-[4/3] w-full rounded-sm object-cover shadow-2xl shadow-black/60" data-id="element-22" data-mp="xgn5av1gi13c" />
        </Reveal>

        <div className="text-center lg:text-left" data-id="element-23" data-mp="4q55c2w14fu5">
          <AnimatedTitle text="Contactenos" className="font-serif text-4xl text-white sm:text-5xl lg:text-6xl" data-id="element-24" data-mp="9q0y15za0kue" />

          <dl className="mt-10 space-y-8" data-id="element-25" data-mp="1jwbpaya1uope">
            <Reveal delay={0.06} data-id="element-26" data-mp="1ev4gqx031lho">
              <dt className="text-xs uppercase tracking-[0.2em] text-neutral-500" data-id="element-27" data-mp="1ew63hyqgnwf8">Llamada</dt>
              <dd className="mt-2" data-id="element-28" data-mp="1a34j5b7hj4o9">
                <a href={contacto.telefonoHref} className="text-xl text-white transition-colors duration-300 ease-out hover:text-[#E0A526] sm:text-2xl" data-id="element-29" data-mp="1632hv35nwd9i">
                  {contacto.telefono}
                </a>
              </dd>
            </Reveal>
            <Reveal delay={0.12} data-id="element-30" data-mp="r5tk9rprmd9c">
              <dt className="text-xs uppercase tracking-[0.2em] text-neutral-500" data-id="element-31" data-mp="r6uxo2u97bu8">Email</dt>
              <dd className="mt-2" data-id="element-32" data-mp="n4zwqzg8j0gz">
                <a href={`mailto:${contacto.email}`} className="text-xl text-[#6EC7EE] underline-offset-4 transition-colors duration-300 ease-out hover:underline sm:text-2xl" data-id="element-33" data-mp="n61axcsjs32x">
                  {contacto.email}
                </a>
              </dd>
            </Reveal>
            <Reveal delay={0.18} data-id="element-34" data-mp="etrbzr8h20g4">
              <dt className="text-xs uppercase tracking-[0.2em] text-neutral-500" data-id="element-35" data-mp="jmkcu40tkomx">Address</dt>
              <dd className="mt-2 text-lg leading-relaxed text-white sm:text-xl" data-id="element-36" data-mp="5vp18jyxrtfn">
                {contacto.direccion.map(linea => <span key={linea} className="block" data-id="element-37" data-mp="9x0x378elawa">
                    {linea}
                  </span>)}
              </dd>
            </Reveal>
          </dl>
        </div>
      </div>
    </section>;
}